// タブを開いた直後に自動でネイティブ印刷を呼び出すスクリプト。iOS以外（Android/PC）の
// PDF/印刷経路で共通して使う（App.js・AdminPanel.js・SuperAdminPanel.js・RegressionTestTab.js）。
//
// window.print()で印刷ダイアログを閉じる（完了・キャンセルいずれも）と、Android
// Chromeではページの表示幅が印刷用のレイアウト幅（A4相当、画面幅よりずっと広い）に
// 据え置かれたまま戻ってくることがある、という報告への対症療法。afterprintイベント
// （ダイアログが閉じると必ず発火する）でviewportのmeta contentを一瞬だけ変えて戻し、
// ブラウザにビューポートの再計算を強制する。
//
// この仮説はヘッドレスブラウザでは検証できない。window.print()はOSネイティブの
// モーダルUIを開くため、印刷ダイアログをキャンセルするという操作自体を自動テストで
// 再現できない（実際にPlaywrightで試したところ、window.print()を呼んでもモーダルは
// 起動せずclientWidthも変化しなかった）。効果は実機での確認待ち（姉妹アプリ
// food-label-assistで同じ対応をしている）。
//
// 1行にしているのはスタイルの都合ではなく必須要件：AdminPanel.js/SuperAdminPanel.jsの
// iOS分岐は印刷用HTMLからこの<script>を取り除くのに/<script>.*?<\/script>/（改行に
// マッチしないパターン）を使っており、複数行にすると正規表現がマッチせずscriptタグが
// そのままiOSのPDF化経路（html2pdf.js）に漏れてしまう。
export const AUTO_PRINT_SCRIPT = `<script>window.onload=function(){window.print();};window.addEventListener('afterprint',function(){var m=document.querySelector('meta[name="viewport"]');if(!m)return;var c=m.content;m.content='width=device-width,initial-scale=1.0001';requestAnimationFrame(function(){m.content=c;});});</script>`;
